import { useMemo } from 'react';
import { useUserAuth } from '~/components/Auth';
import { NAVIGATION_MENU_LIST } from '~/components/Navigation/config/Learner/enum';

const useNavFilter = ({ navConfig }: { navConfig: any }) => {
  const {
    company: { companySettings: { isExperienceCloudEnabled = false } = {} } = {},
  } = useUserAuth();

  const filteredNavConfig = useMemo(
    () =>
      navConfig.filter(
        (item: any) => !(isExperienceCloudEnabled && item.id === NAVIGATION_MENU_LIST.HOME)
      ),
    [navConfig, isExperienceCloudEnabled]
  );

  return {
    filteredNavConfig,
  };
};

export default useNavFilter;
